import React from 'react';
import {CardActions, CreateButton, Datagrid, Filter, List, ReferenceField, TextField, TextInput} from 'react-admin';
import {BillAuthStatusField, DownloadFileContentButton} from "../../components";
import DownloadFoodProductMenuBatchButton from "./DownloadFoodMenuTemplateButton";
import env from "../../env/env";

const KiotProductMenuBatchFilter = (props) => (
    <Filter {...props}>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
    </Filter>
);

const PostActions = ({
                         bulkActions,
                         basePath,
                         currentSort,
                         displayedFilters,
                         exporter,
                         filters,
                         filterValues,
                         onUnselectItems,
                         resource,
                         selectedIds,
                         showFilter,
                         total
                     }) => (
    <CardActions>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        })}
        {/* Add your custom actions */}
        <DownloadFoodProductMenuBatchButton/>
        <CreateButton basePath={basePath}/>
    </CardActions>
);
export const KiotProductMenuBatchList = props => (
    <List filters={<KiotProductMenuBatchFilter/>} {...props} exporter={false} actions={<PostActions/>}>
        <Datagrid>
            <TextField source="id"/>
            <TextField source="description"/>
            <ReferenceField source="kiotConfigId" reference="kiotConfigs" allowEmpty>
                <TextField source="name"/>
            </ReferenceField>
            <BillAuthStatusField source="authStatus"/>
            <DownloadFileContentButton urlPrefix={env.kiotUrl}/>
        </Datagrid>
    </List>
);

export default KiotProductMenuBatchList
